import axios from "axios";
import { useState } from "react";

const Youtube = () => {
    const [url, setUrl] = useState('')
    const [data, setData] = useState(false)
    const [check, setCheck] = useState(true)
    const [activeTab, setActiveTab] = useState(1)
    const [loader, setLoader] = useState(false)
    const numberWithCommans = number => {
        return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    const getData = (e) => {
        e.preventDefault()
        setLoader(true)
        if (check) {
            axios({
                method: 'get',
                url: `https://kazanfar.herokuapp.com/video-info?videoUrl=${url}`
            }).then(response => {
                setLoader(false)
                setCheck(true)
                setData(response.data.info)
            }).catch(err => {
                console.log(err)
            })
            setCheck(false)
        }
    }

    const download = e => {
        window.open(document.querySelector('select').value)
    }
    function bytesToSize(bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
     }
    const styles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
    return (
        <div className="mt-20">
            <div className="text-gray-800 font-bold text-center text-5xl">
                Youtube
            </div>
            <div className="mx-auto">
                <form className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                    <div className="max-w-lg mx-auto p-1 pr-0 flex items-center">
                        <input type="url" placeholder="Video linkini daxil edin"
                            className="focus:outline-none focus:ring-2 focus:ring-purple-600 flex-1 appearance-none rounded shadow p-3 text-grey-dark mr-2 focus:outline-none"
                            value={url} onChange={e => setUrl(e.target.value)} />
                        <button type="submit" onClick={getData}
                            className="bg-purple-600 text-white text-base font-semibold sm:w-full md:w-auto rounded-md shadow-md hover:bg-indigo-600 p-3">Axtar
                        </button>
                    </div>
                </form>
            </div>
            {loader ? (
                <div style={styles}>
                    <img src='/loader.gif' style={{ width: '50px', height: '50px' }} />
                </div>

            ) : (
                data && (
                    <>
                        <div className="w-full justify-center align-center sm:max-w-full lg:flex p-5">
                            <div
                                className="h-48 lg:h-auto lg:w-48 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
                                style={{ backgroundImage: 'url(' + data.videoDetails?.thumbnails[data.videoDetails.thumbnails.length - 1]?.url + ')' }}>
                            </div>
                            <div
                                className="border-r border-b border-l border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                                <div className="mb-8">
                                    <a target="_blank" href={url} className="text-gray-900 font-bold text-xl mb-2">
                                        {data.videoDetails?.title}
                                    </a>
                                    <p className="text-gray-700 text-base">{numberWithCommans(data.videoDetails?.viewCount)} Baxış
                                        • {data.videoDetails?.uploadDate}</p>
                                </div>
                                <a href={data.videoDetails?.author.user_url} className="flex items-center">
                                    <img className="w-10 h-10 rounded-full mr-4"
                                        src={data.videoDetails?.author.thumbnails[0].url}
                                        alt="Avatar of Jonathan Reinink" />
                                    <div className="text-sm">
                                        <p className="text-gray-900 leading-none font-bold">{data.videoDetails?.author.name}</p>
                                        <p className="text-gray-600">{numberWithCommans(data.videoDetails?.author.subscriber_count)}</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="w-full flex align-center justify-center mb-4">
                            <div onClick={e => setActiveTab(1)}
                                className={`cursor-pointer rounded-l p-2 ${activeTab === 1 ? 'text-white bg-gray-800' : 'bg-gray-300 hover:bg-gray-400'}`}>Mp4
                            </div>
                            <div onClick={e => setActiveTab(2)}
                                className={`cursor-pointer rounded-r p-2 ${activeTab === 2 ? 'text-white bg-gray-800' : 'bg-gray-300 hover:bg-gray-400'}`}>Mp3
                            </div>
                        </div>
                        {activeTab === 1 ? (
                            <div class="relative max-w-lg mx-auto p-1 pr-0 flex items-center justify-center">
                                <select className="block appearance-none bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                                    {data.formats.map((item,index) => (
                                        item.mimeType.includes('video/mp4') && (
                                            <option key={index} value={item.url}>{item.qualityLabel}({bytesToSize(item.contentLength)})</option>
                                        )
                                    ))}
                                </select>
                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                </div>
                                <button onClick={download} target="_blank" className="bg-purple-600 text-white text-base font-semibold sm:w-full md:w-auto rounded-md shadow-md hover:bg-indigo-600 p-2">Yüklə</button>
                            </div>
                        ) : (
                            <div class="relative max-w-lg mx-auto p-1 pr-0 flex items-center justify-center">
                                <select className="block appearance-none bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                                    {data.formats.map((item,index) => (
                                        item.mimeType.includes('audio/mp4') && (
                                            <option key={index} value={item.url}>{item.qualityLabel}({bytesToSize(item.contentLength)})</option>
                                        )
                                    ))}
                                </select>
                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                </div>
                                <button onClick={e => download('mp3')} target="_blank" className="bg-purple-600 text-white text-base font-semibold sm:w-full md:w-auto rounded-md shadow-md hover:bg-indigo-600 p-2">Yüklə</button>
                            </div>
                        )}
                    </>
                )

            )}
        </div>
    )
}
export default Youtube
